import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

// Panel desplegable que se dibuja ENCIMA de toda la página (portal al <body>,
// position: fixed) pegado a su botón. Así no lo tapa ninguna cabecera fija de la
// tabla ni lo recorta el scroll del contenedor. Se coloca debajo del botón (o
// encima si no cabe) y nunca se sale por los lados de la pantalla. Se cierra al
// pulsar fuera (ni en el botón ni en el panel) o con Escape.
export default function PanelFlotante({ anchorRef, onCerrar, style, children }) {
  const panelRef = useRef(null);
  const [pos, setPos] = useState({ top: -9999, left: -9999 });

  useLayoutEffect(() => {
    const colocar = () => {
      const a = anchorRef.current?.getBoundingClientRect();
      const p = panelRef.current;
      if (!a || !p) return;
      const w = p.offsetWidth, h = p.offsetHeight, m = 8;
      let left = Math.min(Math.max(m, a.left), window.innerWidth - w - m);
      let top = a.bottom + 6;
      if (top + h > window.innerHeight - m && a.top - h - 6 > m) top = a.top - h - 6;
      setPos({ top: Math.max(m, top), left: Math.max(m, left) });
    };
    colocar();
    window.addEventListener("resize", colocar);
    window.addEventListener("scroll", colocar, true); // también el scroll de la tabla
    return () => { window.removeEventListener("resize", colocar); window.removeEventListener("scroll", colocar, true); };
  }, [anchorRef]);

  useEffect(() => {
    const fuera = (e) => {
      if (panelRef.current?.contains(e.target) || anchorRef.current?.contains(e.target)) return;
      onCerrar();
    };
    const tecla = (e) => { if (e.key === "Escape") onCerrar(); };
    document.addEventListener("mousedown", fuera);
    document.addEventListener("touchstart", fuera);
    document.addEventListener("keydown", tecla);
    return () => {
      document.removeEventListener("mousedown", fuera);
      document.removeEventListener("touchstart", fuera);
      document.removeEventListener("keydown", tecla);
    };
  }, [anchorRef, onCerrar]);

  return createPortal(
    <div ref={panelRef} onClick={(e) => e.stopPropagation()}
      style={{ ...style, position: "fixed", top: pos.top, left: pos.left, zIndex: 3000, maxHeight: "calc(100vh - 16px)", overflowY: "auto" }}>
      {children}
    </div>,
    document.body
  );
}
